import { toast } from '@/components/ui/toast';
import { useRecommendToFriend } from '@/features/friend-recommendations/hooks/use-recommend-to-friend';
import type { CheckInSuccessData, RecommendFriend } from '../types';
import { useCallback, useState } from 'react';
import { router } from 'expo-router';

export function useCheckInSuccess() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState<CheckInSuccessData | null>(null);
  const [saveSheetVisible, setSaveSheetVisible] = useState(false);
  const [friendPickerVisible, setFriendPickerVisible] = useState(false);

  const { mutate } = useRecommendToFriend();

  const showSuccess = useCallback((successData: CheckInSuccessData) => {
    setData(successData);
    setVisible(true);
  }, []);

  const dismiss = useCallback(() => {
    router.replace('/(tabs)');
  }, []);

  const handleSendRecommendations = useCallback(
    (selected: RecommendFriend[]) => {
      if (!data || selected.length === 0) return;

      for (const friend of selected) {
        mutate({ recipient_id: friend.id, menu_item_id: data.menuItemId });
      }

      toast.success(
        selected.length === 1
          ? 'Recommendation sent'
          : `${selected.length} recommendations sent`,
      );
    },
    [mutate, data],
  );

  return {
    visible,
    data,
    showSuccess,
    dismiss,
    saveSheetVisible,
    setSaveSheetVisible,
    friendPickerVisible,
    setFriendPickerVisible,
    handleSendRecommendations,
  };
}
